import { Component, ViewEncapsulation, ViewChild, ElementRef, Inject } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  scrollView: boolean;
  scrollViewTable: boolean;
}



// WEBPACK FOOTER //
// /home/travis/build/zurfyx/angular-contents/example/app/app.component.ts